import {
  Box,
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { NavLink } from "react-router-dom";
import React, { useState } from "react";

export default function NavListDrawer({
  navArrayLinks,
  loggedIn,
  handleCustomVar,
}) {
  const [bodegaOpen, setBodegaOpen] = useState(false);

  const handleClick = (value) => {
    // console.log(value);
    handleCustomVar(value); // Llamamos a la función handleCustomVar y le pasamos el valor deseado
  };

  return (
    <Box sx={{ width: 250, bgcolor: "lightblue" }}>
      <nav>
        <List>
          {navArrayLinks.map((link, index) => (
            <React.Fragment key={index}>
              {link.submenu ? (
                <React.Fragment>
                  <ListItemButton onClick={() => setBodegaOpen(!bodegaOpen)}>
                    <ListItemIcon>{link.icon}</ListItemIcon>
                    <ListItemText primary={link.title} />
                    {bodegaOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={bodegaOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {link.submenu.map((submenuItem, subIndex) => (
                        <ListItemButton
                          onClick={() => handleClick(true)}
                          key={subIndex}
                          component={NavLink}
                          to={submenuItem.path}
                          sx={{ pl: 4 }}
                        >
                          <ListItemIcon>{submenuItem.icon}</ListItemIcon>
                          <ListItemText primary={submenuItem.title} />
                        </ListItemButton>
                      ))}
                    </List>
                  </Collapse>
                </React.Fragment>
              ) : link.title === "Login" && loggedIn ? null : (
                <ListItemButton
                  component={NavLink}
                  to={link.path}
                  onClick={() => handleClick(true)}
                >
                  <ListItemIcon>{link.icon}</ListItemIcon>
                  <ListItemText primary={link.title} />
                </ListItemButton>
              )}
            </React.Fragment>
          ))}
        </List>
      </nav>
    </Box>
  );
}
